module.exports = __webpack_public_path__ + "img/Upload-Client-List.a65d7a48.svg";